// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1478":"706e34df1a726ac6","2036":"1f1a57973594d6a7","2171":"f4e55b17734c7dd5","2739":"e264ced15f8b00af","5133":"7d367fc09a702fbe"}[chunkId] + ".js";
};